<template>
  <div class="study-calendar">
    <Calendar v-if="checkin"
      :firstDay="7"
      :calendarDate="calendarDate"
      :calendarAllowDate="calendarAllowDate"
      :startDay = "startDay"
      @onCurDate="onCurDate"
      @onChangeDate="onChangeDate"
      @onClickDay="onClickDay"
    ></Calendar>
    <div class="calendar-data">
      <div class="celendar-list">
        <Row class="calendar-data-title" :gutter="24">
          <Col :span="8">打卡时间</Col>
          <Col :span="8">题目数量</Col>
          <Col :span="8">操作</Col>
        </Row>
        <Row :gutter="24" v-if="!validDay">
          <Col :span="8">{{curDate}}</Col>
          <Col :span="8">{{calendarList.question_num || 0}}</Col>
          <Col :span="8">
            <span v-if="calendarList.id">
              <Button type="text" class="btn-margin-right" size="small" :to="{name: 'QuestionPaperDetail', query: { id: calendarList.exam_id }}" >查看</Button>
              <Button type="text" class="btn-margin-right" size="small" :to="{name: 'QuestionDailyAdd', query: { date: curDateFormat, id, exam: calendarList.id}}">编辑</Button>
            </span>
            <span v-else>
              <Button type="text" class="btn-margin-right" size="small" :to="{name: 'QuestionDailyAdd', query: { date: curDateFormat, id}}">添加题目</Button>
            </span>
          </Col>
        </Row>
        <Row :gutter="24" v-else>
          <div class="tips" style="text-align:center; padding: 10px;">该天不在活动时间范围内</div>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Calendar from '@/components/Calendar'
export default {
  name: 'QuestionCheckincCalendar',
  components: {
    Calendar
  },
  data() {
    return {
      title: {
        name: '学习日历'
      },
      calendarDate: [],
      calendarAllowDate: [],
      calendarList:{
        question_num: 0,
      },
      curDateFormat: '',
      curDate: '',
      id: this.$route.query.id,
      validDay: false,
      startDay: new Date(this.$route.query.date*1000).format('yyyy-MM-dd'),
      checkin: {}
    }
  },
  created() {
    this.requestCheckin();
  },
  methods: {
    // on event
    onCurDate(date) {
      this.requestcalendarDate(date)
      this.changeCurDate(date)
    },
    onChangeDate(date) {
      this.calendarList = []
      this.changeCurDate(date)
    },
    onClickDay(date) {
      let curTimeStamp = (new Date(date + ' 00:00:00')).getTime() / 1000;
      this.validDay = false
      if(curTimeStamp < this.checkin.start_time || curTimeStamp > this.checkin.end_time) {
        this.validDay = true
      }
      this.requestcalendar(date)
      this.changeCurDate(date)
    },
    // other
    changeCurDate(date) {
      const ary = date.split('-')
      this.curDate = ary[1] + '月' + ary[2] + '日'
      this.curDateFormat = date
    },
    // request
    requestcalendarDate(date) {
      let curTimeStamp = (new Date(date + ' 00:00:00')).getTime() / 1000;
      if(curTimeStamp > this.calendarAllowDate[0] && curTimeStamp < this.calendarAllowDate[1]) {
        this.validDay = false;
      }
      this.requestcalendar(date)
      this.$forceUpdate();
    },

    requestCheckin() {
      this.$http.get(`/api/exam/checkin/${this.id}`).then(data => {
        this.startDay = new Date( data.start_time*1000 ).format('yyyy-MM-dd');
        this.checkin = data;
        this.calendarDate = []
        for (const i in data.daily_checkin) {
          if (!data.daily_checkin[i]) continue
          this.calendarDate.push(new Date(parseInt(data.daily_checkin[i].date*1000)).format('yyyy-MM-dd'))
        }
        this.calendarAllowDate = [
          data.start_time,
          data.end_time
        ]
      })
    },
    requestcalendar(date) {
      let  id = this.$route.query.id;
      this.$http.get(`/api/exam/daily/${id}/${date}`).then(data => {
        this.calendarList = data
        this.$forceUpdate();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.study-calendar {
  header {
    margin-bottom: 5px;
  }
  .info {
    padding: 0 0 10px 10px;
    .date {
      font-size: 15px;
      color: #000;
      margin-right: 15px;
    }
    .calendar-count {
      font-size: 12px;
      color: #8c8c8c;
    }
  }
  .calendar-data{
    line-height: 30px;
    background: #efefef;
    margin: 10px;
    padding: 0 10px;
    .celendar-list{
      padding: 10px;
    }
    .calendar-data-title{
      background: #fff;
    }
  }

}
</style>
